<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	// Stores
	import NoteStore from '@/Stores/User/NoteStore.js';
	import ACLStore from '@/Stores/ACLStore.js';
	// Services
	import { getUrlParameter, setUrlParameter, paginationBuilder } from '@/Services/Helpers.js';
	// Constants
	import { UserNoteCategories, UserNoteCategoryNames } from '@/Constants/UserNotes.js';
	// Components
	import Pagination from '@/Components/Pagination.svelte';
	// Partials
	import AddNote from '@/Partials/User/_AddNote.svelte';

	dayjs.extend(localizedFormat);

	export let user;

	let showAddNote = false;
	let pageNo = getUrlParameter('notes_page') || 1;
	let pageSize = 25;
	let selectedCategory = UserNoteCategories.TRADING;

	$: user && getUserNotes();
	$: links = $NoteStore && $NoteStore.count() && paginationBuilder(NoteStore.getPagination());

	function changePage(e) {
		if (e) {
			pageNo = e.detail.page;
			getUserNotes();
			setUrlParameter('notes_page', pageNo);
		}
	}

	function getUserNotes() {
		return NoteStore.getUserNotes(user.id, selectedCategory, {
			size: pageSize,
			number: pageNo
		});
	}

	function handleTabChange(category) {
		pageNo = 1;
		selectedCategory = category;
		getUserNotes();
	}
</script>

{#if $ACLStore && ACLStore.granted('user_notes.create')}
	<AddNote bind:open={showAddNote} {user} onSave={getUserNotes} />
{/if}

{#if $NoteStore && $ACLStore && ACLStore.granted('user_notes.read')}
	<div class="flex flex-col md:w-1/2 text-dark-grey min-h-78 overflow-y-hidden" style="max-height: calc(43vh)">
		<!-- Header -->
		<div class="flex items-center px-2 bg-dark-grey text-light">
			<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">Notes</h2>
			{#if $ACLStore && ACLStore.granted('user_notes.create')}
				<button on:click={() => (showAddNote = true)} class="py-1 btn btn-primary focus:outline-none">
					Add Note
				</button>
			{/if}
		</div>

		<!-- Tabs -->
		<div class="flex space-x-2 px-2 py-1 bg-gray-100 text-sm font-medium">
			{#each Object.keys(UserNoteCategories) as categoryKey}
				<button
					class="px-3 py-1 rounded"
					class:bg-green-500={selectedCategory === UserNoteCategories[categoryKey]}
					class:text-white={selectedCategory === UserNoteCategories[categoryKey]}
					class:font-bold={selectedCategory === UserNoteCategories[categoryKey]}
					class:bg-gray-200={selectedCategory !== UserNoteCategories[categoryKey]}
					on:click={() => handleTabChange(UserNoteCategories[categoryKey])}
				>
					{UserNoteCategoryNames[UserNoteCategories[categoryKey]]}
				</button>
			{/each}
		</div>

		<!-- Notes Table -->
		<div class="flex flex-col bg-gray-50 h-full" style="max-height: calc(100% - 36px)">
			<div class="overflow-y-scroll flex flex-col">
				<table class="text-sm">
					<tr>
						<th class="sticky top-0 bg-grey text-light text-left pl-2 py-1.5 w-px">Date</th>
						<th class="sticky top-0 bg-grey text-light text-left py-1.5">Note</th>
						<th class="sticky top-0 bg-grey text-light text-left pr-2 py-1.5 w-px">Admin</th>
					</tr>
					{#each ($NoteStore && $NoteStore.all()) ?? [] as note (note.id)}
						<tr class="border-b">
							<td class="pl-2 py-1.5 pr-3">
								<div class="flex flex-col justify-center items-start whitespace-nowrap">
									<div class="hidden md:block">{dayjs(note.created_at).format('lll')}</div>
									<div class="md:hidden">{dayjs(note.created_at).format('MMM D, YYYY')}</div>
									<div class="md:hidden">{dayjs(note.created_at).format('h:mm:ss A')}</div>
								</div>
							</td>
							<td class="py-1.5 whitespace-pre-wrap pr-3">{note.note}</td>
							<td class="pr-2 py-1.5">{note.admin_user && note.admin_user.name ? note.admin_user.name : 'System'}</td>
						</tr>
					{/each}
				</table>
			</div>

			{#if $NoteStore.count()}
				<Pagination {links} on:click={changePage} className="py-8 bg-gray-100" />
			{/if}
		</div>
	</div>
{/if}
